import React, { Component } from "react";

class CardTableComponent extends Component {
    render() {
        let { _pageScope, moduleId, tables = [], tabs = [], multiConfig = {}, ...others } = this.props;
        tables.forEach(table => {
            if (Array.isArray(table?.tabs)) {
                tabs.push(...table.tabs);
            }
        });
        tabs.forEach(tab => {
            let code = tab?.items?.code;
            if (code) {
                let oldConfig = multiConfig[code] || {};
                multiConfig[code] = { ...others, ...tab, ...oldConfig };
            }
        });

        return (
            <footer className={`lowcode-cardtable ${others.className}`}>
                {_pageScope.props.cardTable.createCardTable(moduleId, {
                    ...others,
                    multiConfig,
                })}
            </footer>
        );
    }
}

export default CardTableComponent;